<template>
	<li
		class="sidebar-cart__list-item"
	>
		<div class="sidebar-cart__list-item-image">
			<img
				class="sidebar-cart__list-item-image-element"
				v-if="item.image.length"
				:src="item.image[0].path"
				alt="Product Image"
			>
		</div>
		<div class="sidebar-cart__list-item-info">
			<div
				class="sidebar-cart__list-item-name"
				v-html="item.name"
			/>
			<div
				class="sidebar-cart__list-item-meta"
				v-if="item.unit"
				v-html="item.unit"
			/>
			<QuantityCounter
				:quantity="item.quantity"
				:locked="locked"
				base-class="sidebar-cart__list-item-quantity"
				@sub="$emit('sub')"
				@add="$emit('add')"
			/>
		</div>
		<div
			class="sidebar-cart__list-item-price"
			v-html="$options.filters.madpricecent(item.originalTotal, 'short')"
		/>
	</li>
</template>

<script>
import QuantityCounter from '@/components/QuantityCounter';

export default {
	components: {
		QuantityCounter,
	},
	props: {
		item: Object,
		locked: Boolean,
	},
	mounted() {
		const parent = this.$el.parentNode;
		parent.scrollTop = parent.scrollHeight;
	}
}
</script>

<style>

</style>
